<template>
  <div class="block">
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="pageSize" :page-size="ps" layout="prev, pager, next" :total="TotalCount">
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: "pagination",
  data() {
    return {
      currentPage: 1,
      pageSize: this.type
    };
  },
  props: {
    TotalCount: Number,
    ps: Number,
    type: Number
  },
  methods: {
    handleSizeChange(val) {
      document.documentElement.scrollTop = 0
      this.$emit('ps', val)
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      document.documentElement.scrollTop = 0
      this.$emit('pi', val)
      // console.log(`当前页: ${val}`);
    },
  },
};

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.block {
  width: 100%;
  text-align: center;
  margin: 60px 0 30px;
}

/* /deep/.block .el-icon-arrow-right:before{
  content: "下一页"
}

/deep/.block .el-icon-arrow-left:before {
  content: "上一页"
} */
/deep/.block .el-icon-d-arrow-right:before{
  content: "\E794";
}
/deep/.el-pagination.is-background .el-pager li.more{
  border: none;
}

</style>



// WEBPACK FOOTER //
// src/components/pagination.vue